<template>
  <div class="screenshot-card">
    <div ref="magglass" class="img-magnifier-glass"></div>
    <img ref="screenshotimg" :src="imgUrl" class="screenshot-image" />
  </div>
</template>

<script>

// Mixins
import domReady from '@/mixins/DOMReady.js'

export default {
  name: 'MagnifiedScreenshotImage',
  mixins: [domReady],
  props: {
    zoom: Number,
    imgUrl: String
  },
  data () {
    return {
      img: null,
      glass: null,
      bw: 3,
      w: 0,
      h: 0
    }
  },
  watch: {
    imgUrl: { // Watch the imgUrl because this is computed each time option data is built via scraping so we can use it to re-init the magnifier each time
      handler: function (value) {
        if (value) {
          this.$domReady(() => {
            // DOM updated so screenshot element has a size
            this.startMagnifier()
          })
        }
      },
      immediate: true // Make this fire immediately as well so we can use it to init the magnifier first time rather than usig mounted hook as well
    }
  },
  methods: {
    startMagnifier: function () {
      this.img = this.$refs['screenshotimg']//document.getElementById(imgID);

      /* Create magnifier glass: */
      this.glass = this.$refs['magglass']//document.createElement("DIV");

      /* Insert magnifier glass: */
      // this.img.parentElement.insertBefore(this.glass, this.img);
      if (this.glass) {

        /* Set background properties for the magnifier glass: */
        this.glass.style.backgroundImage = "url('" + this.imgUrl + "')";
        this.glass.style.backgroundRepeat = "no-repeat";
        this.glass.style.backgroundSize = (this.img.width * this.zoom) + "px " + (this.img.height * this.zoom) + "px";
        this.bw = 3;
        this.w = this.glass.offsetWidth / 2;
        this.h = this.glass.offsetHeight / 2;

        /* Execute a function when someone moves the magnifier glass over the image: */
        this.glass.addEventListener("mousemove", this.moveMagnifier);
        /* and also for touch screens */
        this.glass.addEventListener("touchmove", this.moveMagnifier);
      }

      if (this.img) {
        /* Execute a function when someone moves the magnifier glass over the image: */
        this.img.addEventListener("mousemove", this.moveMagnifier);

        /* and also for touch screens */
        this.glass.addEventListener("touchmove", this.moveMagnifier);
      }
    },
    getCursorPosition: function (e) {
      let a, x = 0, y = 0
      e = e || window.event
      /* Get the x and y positions of the image: */
      a = this.img.getBoundingClientRect();
      /* Calculate the cursor's x and y coordinates, relative to the image: */
      x = e.pageX - a.left
      y = e.pageY - a.top
      /* Consider any page scrolling: */
      x = x - window.pageXOffset
      y = y - window.pageYOffset
      return {x : x, y : y}
    },
    moveMagnifier: function (e) {
      let pos, x, y
      /* Prevent any other actions that may occur when moving over the image */
      e.preventDefault()
      /* Get the cursor's x and y positions: */
      pos = this.getCursorPosition(e)
      x = pos.x
      y = pos.y
      /* Prevent the magnifier glass from being positioned outside the image: */
      if (x > this.img.width - (this.w / this.zoom)) {x = this.img.width - (this.w / this.zoom);}
      if (x < this.w / this.zoom) {x = this.w / this.zoom;}
      if (y > this.img.height - (this.h / this.zoom)) {y = this.img.height - (this.h / this.zoom);}
      if (y < this.h / this.zoom) {y = this.h / this.zoom;}
      /* Set the position of the magnifier glass: */
      this.glass.style.left = (x - this.w) + "px";
      this.glass.style.top = (y - this.h) + "px";
      /* Display what the magnifier glass "sees": */
      const bgPos = "-" + ((x * this.zoom) - this.w + this.bw) + "px -" + ((y * this.zoom) - this.h + this.bw) + "px"
      this.glass.style.backgroundPosition = bgPos
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.screenshot-card {
  overflow-y: auto;
  overflow-x: hidden;
  position: relative !important;
}

.screenshot-image {
  max-width: 100%;
  background-size: contain;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  /* Set the size of the magnifier glass: */
  width: 150px;
  height: 150px;
  z-index: 2;
}

</style>
